<template>
  <exo-help-dialog title="Antenna gain">
    <p>
      The antenna gain corresponds to the directivity minus the antenna feed
      losses (both in <katex-element expression="dB" />). The directivity
      represents how much the antenna concentrates the trasmitted power in a
      fixed direction (in a coordinate system fixed to the antenna). It is
      usually measured as the power directed in the peak direction divided by
      the same power when distributed isotropically (equally in all directions).
      The feed losses, on the other hand, represent simply the eventual losses
      associated with getting the power from the antenna input to the radiating
      element.
    </p>
    <p>
      For a transmitter, the gain will be used to compute the
      <katex-element expression="\mathrm{EIRP}" />.
    </p>
    <tooltipEquationEIRP />
    <p>
      For a receiver, the gain will be used to compute the
      <katex-element expression="G/T" />.
    </p>
    <tooltipEquationGT />
    <tooltipEquationEbN0 />
  </exo-help-dialog>
</template>

<script>
import tooltipEquationEbN0 from './tooltipEquationEbN0.vue'
import tooltipEquationEIRP from './tooltipEquationEIRP.vue'
import tooltipEquationGT from './tooltipEquationGT.vue'
export default {
  name: 'tooltipAntennaGain',
  components: {
    tooltipEquationEbN0,
    tooltipEquationEIRP,
    tooltipEquationGT
  }
}
</script>
